export function SkeletonProductCard() {
  return (
    <article
      aria-hidden="true"
      className="flex h-full flex-col gap-3 rounded-md border border-black/5 bg-white p-3 shadow-sm"
    >
      <div className="aspect-square w-full animate-pulse rounded bg-black/10" />

      <div className="h-3 w-1/2 animate-pulse rounded bg-black/10" />

      <div className="flex flex-col gap-1.5">
        <div className="h-3.5 w-5/6 animate-pulse rounded bg-black/10" />
        <div className="h-3.5 w-3/4 animate-pulse rounded bg-black/10" />
      </div>

      <div className="h-3 w-1/3 animate-pulse rounded bg-black/10" />

      <div className="flex gap-1.5">
        <div className="h-6 w-12 animate-pulse rounded bg-black/10" />
        <div className="h-6 w-12 animate-pulse rounded bg-black/10" />
        <div className="h-6 w-12 animate-pulse rounded bg-black/10" />
      </div>

      <div className="h-4 w-20 animate-pulse rounded bg-black/10" />

      <div className="mt-auto flex flex-col gap-2 pt-1">
        <div className="h-8 w-full animate-pulse rounded bg-black/10" />
        <div className="h-8 w-full animate-pulse rounded bg-black/10" />
      </div>
    </article>
  );
}
